import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgInformatie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <mask
      id="Informatie_svg__a"
      width={26}
      height={26}
      x={7}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M20 7a13 13 0 1 0 0 26 13 13 0 0 0 0-26m1.55 21h-3.1V17.56h3.1zm-.12-12.62A2 2 0 0 1 20 16a1.92 1.92 0 0 1-1.42-.57 2 2 0 0 1 0-2.81A1.92 1.92 0 0 1 20 12a2 2 0 0 1 1.43.57 2 2 0 0 1 0 2.81"
      />
    </mask>
    <g mask="url(#Informatie_svg__a)">
      <path
        fill="#F18700"
        d="M12.86 15.42.61 8.35 7.68-3.9z"
      />
      <path
        fill="#F18700"
        d="M-6.46 20.6.61 8.35l12.25 7.07z"
      />
      <path
        fill="#F7A941"
        d="M7.68-3.9.61 8.35l-12.25-7.07z"
      />
      <path
        fill="#F18700"
        d="M18.04 34.74 5.79 27.67l7.07-12.25zM12.86 15.42 5.79 27.67-6.46 20.6z"
      />
      <path
        fill="#F7A941"
        d="m-1.28 39.91 7.07-12.24 12.25 7.07zM32.18 10.24 19.93 3.17 27-9.07z"
      />
      <path
        fill="#F18700"
        d="m7.68-3.9 12.25 7.07-7.07 12.25z"
      />
      <path
        fill="#F7A941"
        d="m12.86 15.42 7.07-12.25 12.25 7.07z"
      />
      <path
        fill="#F18700"
        d="M27-9.07 39.25-2l-7.07 12.24zM32.18 10.24 39.25-2l12.24 7.07zM32.18 10.24l12.24 7.08-7.07 12.24z"
      />
      <path
        fill="#F7A941"
        d="m51.49 5.07-7.07 12.25-12.24-7.08zM12.86 15.42l12.25 7.07-7.07 12.25z"
      />
      <path
        fill="#F18700"
        d="m37.35 29.56-12.24-7.07 7.07-12.25z"
      />
      <path
        fill="#F7A941"
        d="m32.18 10.24-7.07 12.25-12.25-7.07zM18.04 34.74l7.07-12.25 12.24 7.07zM42.53 48.88l-12.25-7.07 7.07-12.25z"
      />
      <path
        fill="#F18700"
        d="m37.35 29.56-7.07 12.25-12.24-7.07z"
      />
    </g>
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgInformatie);

export default ForwardRef;
